<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">Projetos</h3>
            <md-button class="md-primary" to="/projeto/novo">Adicionar novo</md-button>
        </md-toolbar>


        <v-card elevation="0">
            <v-container>
                <v-row class="mb-3">
                    <v-col cols="5" md="5">
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-menu
                                    ref="menuProIniDe"
                                    v-model="datesMenu.pro_ini_de"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="proInicioDateRange"
                                            label="Data de inicio"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    range
                                    v-model="filters.projeto_inicio"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="6" md="6">
                                <v-menu
                                ref="menuProFinDe"
                                v-model="datesMenu.pro_fin_de"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="proFinDateRange"
                                        label="Data de finalização"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    range
                                    v-model="filters.projeto_dataFinalizado">
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>


                    </v-col>

                    <v-col cols="4" md="4">
                        <v-autocomplete
                        label="Cliente"
                        v-model="filters.cli_id"
                        :items="clientes"
                        item-value="cli_id"
                        item-text="cli_nome_fantasia"
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="2" md="3">
                        <v-select
                        v-model="filters.status"
                        item-text="label"
                        item-value="value"
                        :items="projectStatus"
                        label="Status do Projeto"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-btn
                color="primary"
                outlined
                @click="getListItem()"
                >Aplicar Filtros</v-btn>
                
                <v-btn
                class="ml-3"
                outlined
                dense
                @click="clearFilters()"
                >Limpar Filtros</v-btn>
            </v-container>

            
        </v-card>


        <v-container class="mt-5">
            <v-data-table
                :items="projetos"
                :headers="projetosHeader"
                md-elevation="0"
                :server-items-length="totalProjetos"
                :options.sync="options"
                class="elevation-0 mt-4"
            >
                <template v-slot:item.projeto_inicio="{ item }">
                    {{ item.projeto_inicio | moment("D/MM/Y") }}
                </template>

                <template v-slot:item.status="{ item }">
                    <v-chip class="ma-2 white--text" :color="item.status['color']">
                        {{item.status['label']}}
                    </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                    <md-button :to="`/projeto/editar/${item.projeto_id}`"><md-icon>edit</md-icon></md-button>
                </template>
            </v-data-table>
        </v-container>

        

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>

        <md-dialog-confirm
        :md-active.sync="removeItemDialog"
        md-title="Deseja realmente remover este item?"
        md-confirm-text="Remover"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelDialogRemoveItem"
        @md-confirm="onConfirmDialogRemoveItem" />
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../../components/main-template.vue'
import { api } from '../../../services/api'

export default {
    name: 'projeto-list',
    components: {
        mainTemplateVue
    },
    data: () => ({
      date: null,
      projectStatus: [
        {
            label: "Todos",
            value: null
        },
        {
            label: "Iniciado",
            value: "iniciado"
        },
        {
            label: "Não iniciado",
            value: "nao_iniciado"
        },
        {
            label: "Atrasado",
            value: "atrasado"
        },
        {
            label: "Orçamento",
            value: "orcamento"
        },
        {
            label: "Cancelado",
            value: "cancelado"
        },
        {
            label: "Finalizado",
            value: "finalizado"
        },
      ],
      categorias: [
          {
            label: "Todos",
            value: null
          },
          {
            label: "Aluguel",
            value: 1,
          },
          {
            label: "Venda",
            value: 0,
          }
      ],
      datesMenu: {
        pro_ini_de: false,
        pro_ini_ate: false,
        pro_fin_de: null,
        pro_fin_ate: null
      },
      filters: {
        projeto_inicio: [],
        projeto_dataFinalizado: [],
        cli_id: null,
        status: null
      },
      clientes: [],
      removeItemDialog: false,
      idToBeRemoved: null,
      snackMessage: false,
      showSnackMessage: false,
      search: null,
      rowsPerPage: 3,
      options: {},
      totalProjetos: 0,
      projetosHeader: [
        {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'projeto_id',
        },
        {
            text: 'Cliente',
            align: 'start',
            sortable: false,
            value: 'cliente.cli_nome_fantasia',
        },
        {
            text: 'Data de inicio',
            align: 'start',
            sortable: false,
            value: 'projeto_inicio',
        },
        {
            text: 'Status',
            align: 'start',
            sortable: false,
            value: 'status',
        },
        { 
            text: '', 
            value: 'actions', 
            align: 'center',
            sortable: false 
        },
      ],
      projetos: [],
      paginatedProjetos: []
    }),
    computed: {
      proInicioDateRange () {
        return this.filters.projeto_inicio.join(' ~ ')
      },
      proFinDateRange () {
        return this.filters.projeto_dataFinalizado.join(' ~ ')
      },
    },
    watch: {
      options: {
        handler () {
          this.getListItem()
        },
        deep: true,
      },
    },
    methods: {
      clearFilters(){
        this.filters = {
            projeto_inicio: [],
            projeto_dataFinalizado: [],
            cli_id: null,
            status: null
        };

        this.getListItem()
      },
      getStatusColor(status){
          let colors = {
              "Iniciado": "primary",
              "Finalizado": "green",
              "Orçamento": "",
              "Cancelado": "red"
          };

          return colors[status]
      },
      async getListItem(){
        const { page, itemsPerPage } = this.options

        let req = await api().get(`projeto?page=${page}&per_page=${itemsPerPage}`, {
            params: this.filters
        })

        this.projetos = req.data.data.data
        this.totalProjetos = req.data.data.total
      },
      
      removeItem(id){
        this.removeItemDialog = true
        this.idToBeRemoved = id
      },

      async onConfirmDialogRemoveItem(){
        api().delete(`/estoque/medida/${this.idToBeRemoved}`).then(() =>  {
          this.showSnackMessage = true
          this.snackMessage = "Registro removido com sucesso"
          this.getListItem()
        }).catch(() => {
          this.showSnackMessage = true
          this.snackMessage = "Falha ao remover o item, verifique se há itens vinculados a ele e tente novamente."
        })
      },

      onCancelDialogRemoveItem(){
        this.idToBeRemoved = null
        this.removeItemDialog = false
      },
      async getClientes(){
        let req = await api().get(`cliente`)
        this.clientes = req.data.data
      }
    },
    created () {
      this.getListItem()
      this.getClientes()
    }
}
</script>

<style>

</style>